import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=f42db24e&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=js&"
export * from "./profile.vue?vue&type=script&lang=js&"
import style0 from "./profile.vue?vue&type=style&index=0&id=f42db24e&prod&lang=css&"
import style1 from "./profile.vue?vue&type=style&index=1&id=f42db24e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f42db24e",
  null
  
)

export default component.exports